export const CustomerInfoSuccess = 'CUSTOMER_INFORMATION_SUCCESS';

export function setCustomerInformationAction(data) {
  return {
    type: CustomerInfoSuccess,
    payload: data,
  };
}
